<svg xmlns="http://www.w3.org/2000/svg" width="20" height="40" viewBox="0 0 20 40" fill="none">
  <path d="M1 1C1 1 10 9.55 10 20M10 20V39M10 20C10 9.55 19 1 19 1M10 39L15 33.7222M10 39L5 33.7222" stroke="#1F1F1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>